var quoteDataArray;
  var orderDataArray;
  var search = '';
  var page = 1;
  var limit = 6;
  var sortOrder = 'desc';
  var orderField = 'modified_at';

  const customerStatus = {
    "awaiting quote": "Awaiting Quote",
    "offer received": "Offer Received",
    "send your clubs to us": "Send Your Clubs",
    "rejected offer": "Rejected Offer",
    "Take Clubs to DPD Drop Off Point": "Take Clubs to DPD",
    "Please Pay Delivery Cost": "Pay Delivery Cost",
    "we have received your clubs": "At Warehouse",
    "please review your revised offer": "Review Offer",
    "please pay the return delivery": "Pay for Delivery",
    "Your Clubs Are On Their Way": "Clubs on way",
    "payment sent": "Payment Sent",
  };
  
  function formatDateTime(dateTimeString) {
      let date = new Date(dateTimeString);

      let hours = String(date.getHours()).padStart(2, '0');
      let minutes = String(date.getMinutes()).padStart(2, '0');
      let day = String(date.getDate()).padStart(2, '0');
      let month = String(date.getMonth() + 1).padStart(2, '0');
      let year = String(date.getFullYear()).slice(-2);

      return `${day}-${month}-${year}`;
  }

function getQuotes() {
  $.ajax({
    url: "https://deft.affordablegolf.co.uk/secondhand/dashboard/getQuotes.php",
    method: "POST",
    dataType: "json",
    data: {
      customer_id: window.customerQuotesConfig?.customerId || null,
      order: sortOrder,
      order_field: orderField,
      search: search,
      page: page,
      limit: limit
    },
    success: function (data) {
      if (data.quotes.length) {
        $(".quote-grid-wrapper").show();
        $(".no-data").hide();
        const html = showQuoteData(data.quotes);
        $(".quotation-body").html(html);

        // Ensure page is within bounds
        page = page ? page : 1;
        if (page > data.totalPages) page = data.totalPages;

        let btn = '';
        const total = data.totalPages;

        // Only show Prev/Next if total pages > 1
        if (total > 1) {
            btn += `<button class="page" id="page_prev" data-id="${page > 1 ? page - 1 : 1}">Prev</button>`;
        }

        // Show all page buttons
        for (let i = 1; i <= total; i++) {
            if (i === page) {
                btn += `<button class="page spec_btn" id="page_${i}" data-id="${i}"><a>${i}</a></button>`;
            } else {
                btn += `<button class="page" id="page_${i}" data-id="${i}"><a>${i}</a></button>`;
            }
        }

        if (total > 1) {
            btn += `<button class="page" id="page_next" data-id="${page < total ? page + 1 : total}">Next</button>`;
        }

        $(".pagination").html(btn);

        // Page click handler
        $(".page").bind("click", function (e) {
          page = parseInt($(e.currentTarget).attr('data-id'));
          getQuotes();
        });

        // Highlight current page
        $("#page_" + page).css({ "background-color": "black" });
        $("#page_" + page + " a").css({ "color": "white" });
      } else {
        $(".quote-grid-wrapper").hide();
        $(".no-data").show();
      }
    },
  });
}

  function showQuoteData(data){
      let html = '';
      html += $.map(data, function(item, id) {
      let itemDetails = '';
      if(parseInt(item.cnt)){
        if(item.customer_status != "Paid" && item.customer_status != "quote closed") {
          itemDetails += `<div class="btn-group"> <div class="add-more-item"><a href="/pages/sell-golf-clubs-search/${item.id}">Add More Item</a></div><div class="merge-quote"><a href="/pages/your-quote-offer/${item.id}?mergeQuote=1">Merge Quote</a></div></div>`;
        }
        
        itemDetails += `
          <div class="item-head">
            <div><strong></strong></div>
            <div><strong>Name</strong></div>
            <div><strong>Currency</strong></div>
            <div><strong>Value</strong></div>
            <div><strong>Condition</strong></div>
          </div>
          <div class="item-body">
        `;
        
        const pname = JSON.parse(item.pname || "[]");
        const pnames = JSON.parse(item.pnames || "[]");
        const pimages = JSON.parse(item.pimage || "[]");
        const currencies = JSON.parse(item.qtcurrencies || "[]");
        const condition = JSON.parse(item.qtCondition || "[]");
        const cash = JSON.parse(item.qtcash || "[]");
        const voucher = JSON.parse(item.qtvoucher || "[]");
        
          itemDetails += $.map(pname,function(item,index){
          return `
            <div class="item-details">
              <div>
                ${pimages[index] 
                  ? `<img src="https://deft.affordablegolf.co.uk/secondhand/images/${pimages[index]}" alt="${item || "Image"}" width="100">` 
                  : '<img src="https://deft.affordablegolf.co.uk/secondhand/web/images/placeholder_image.png" alt="Image" width="100">'}
              </div>
              <div style="text-decoration: underline; color: #23438C;">${item || pnames[index]}</div>
              <div>${currencies[index] || "-"}</div>
              <div>&pound;${parseFloat(currencies[index] == 'cash' ? cash[index] : voucher[index]).toFixed(2)}</div>
              <div class="status-wrapper"><div style="background: ${btncolor[condition[index]]}">${condition[index] || "-"}</div></div>
            </div>
          `
        }).join('');
        itemDetails += "</div>";
      }
      let quoteId = '';
      if(item.status == "offer adjusted" || item.status == "quote offered" || item.status == "active"){
        quoteId = `<div><a style="text-decoration: underline; color: #23438C;" href="/pages/your-quote-offer/${item.id}">${item.id}</a></div>`;
      }
      else if (!parseInt(item.isOrderCreated) && (item.status == "customer accepted" || (item.status == "customer rejected" && item.total_accepted_item))){
        quoteId = `<div><a style="text-decoration: underline; color: #23438C;" href="/pages/club-checkout/${item.id}">${item.id}</a></div>`;
      }
      else{
        quoteId = `<div style="text-decoration: underline; color: #23438C;">${item.id}</div>`;
      }
      return `
        <div class="grid-row" data-id=${item.id} data-status="${item.status}">
          <div class="details" data-index=${id}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M7.5 15L12.5 10L7.5 5" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg></div>
          ${quoteId}
          <div>${formatDateTime(item.created_at)}</div>
          <div>${item.modified_at ? formatDateTime(item.modified_at) : '-'}</div>
          <div>${item.status !== 'active' && item.total_voucher_value ? `&pound;${parseFloat(item.total_voucher_value).toFixed(2)}` : '-'}</div>
          <div>${item.status !== 'active' && item.total_cash_value ? `&pound;${parseFloat(item.total_cash_value).toFixed(2)}` : '-'}</div>
          ${item.customer_status ? `<div class="status-wrapper"><div>${customerStatus[item.customer_status] ? customerStatus[item.customer_status] : item.customer_status}</div></div>` : `<div>-</div>`}
          <div data-id="${item.id}" style="text-decoration: underline; color: #23438C;" class="new-msg ${parseInt(item.unread_messages) ? `show_msg` : ''}">${parseInt(item.unread_messages) ? `${item.unread_messages} New messages` : 'none'}</div>
          <div class="item-list" id="info-${id}" style="display:none">
            ${itemDetails || "<div>No items available.</div>"}
          </div>
        </div>
      `;
    }).join('');
  
    return html;
  }

  $(document).ready(function(){
    getQuotes();
  });

  $(document).on("click",".grid-row",function(event){
    if ($(event.target).closest(".details").length > 0) {
        event.stopPropagation();
        return;
    }
    if ($(event.target).closest(".new-msg").length > 0) {
        event.stopPropagation();
        return;
    }
    if($(this).data("status") != 'active'){
      let id = $(this).data("id");
      window.location.href = `/pages/your-quote-offer/${id}`;
    }
  })

  $(".quotation-body").on("click", ".details", function(e) {
    if ($(e.target).is("a")) {
        return;
    }
    const index = $(this).data("index");
    const infoElement = $(`.quotation-body #info-${index}`);
    infoElement.toggle();
    if (infoElement.is(":visible")) {
        $(this).find("svg").css({"transform": "rotate(90deg)"});
    } else {
        $(this).find("svg").css({"transform": "rotate(0deg)"});
    }
});

  $(".quotation-body").on("click",".new-msg ",function(e){
    let quotationId = $(this).data("id");
    window.location.href = `/pages/your-quote-offer/${quotationId}?message=1`;
    
  })

  $(".quote-grid .pagination").on("click", ".page", function(e) {
    e.preventDefault();
    const page = $(this).data("page");
    $(".quote-grid .page").removeClass("active");
	$(this).addClass("active");
    const html = showQuoteData(quoteDataArray[page])
    $(".quotation-body").html(html)
  });

  $(".sort-order").click(function(){
    $(".sort-order").not(this).attr("data-order","asc").removeClass("desc")
    sortOrder = $(this).attr("data-order") == 'asc' ? 'desc' : 'asc';
    orderField = $(this).data("name");
    $(this).removeClass($(this).attr("data-order"));
    $(this).addClass(sortOrder);
  	$(this).attr('data-order', sortOrder);
    getQuotes();
  })

  $('input[name=search]').keyup(function(){
      search = $(this).val().toLowerCase();
      getQuotes();
  })

  $('input[name="search"]').on('input', function () {
      if ($(this).val().trim() !== "") {
          $('.search-close').show();
      } else {
          $('.search-close').hide();
      }
  });

  $('.search-close').on('click', function () {
      search = '';
      $('input[name="search"]').val('')
      getQuotes()
      $(this).hide();
  });